export default __webpack_public_path__ + "static/media/toxys-wave-light.062f4600.png";